import React, {useState, useEffect} from 'react'
import axios from 'axios'
import Cookies from 'js-cookie'
import API_BASE_URL from '../../../config/api'
import Topbar from '../mini-comp/Topbar'
import Sidebar from '../mini-comp/Sidebar'


const ExEmployees = () => {
  return (
    <div>
        <Topbar/>
        <Sidebar/>
      
    </div>
  )
}

export default ExEmployees
